<template>
    <div>
        <div>
            <img v-if="procedure==null" class="QA-header-img" src="../../static/image/security/QA/QA-header.png">
            <img v-else class="QA-header-img" :src="procedure.headImage">
        </div>
        <div>
            <img v-if="procedure==null" class="QA-header-img" src="../../static/image/security/QA/QA-main.png">
            <img v-else class="QA-header-img" :src="procedure.contentImage">
        </div>
    </div>
</template>

<script>
export default {
  name: "QA",
  data() {
    return {
      procedure: null
    }
  },
  metaInfo: {
    title: '质保卡', // set a title
    meta: [{                 // set meta
      name: 'keyWords',
      content: '质保卡'
    }],
    link: [{                 // set link
      rel: 'description',
      content: '这是索康的官网的质保卡'
    }]
  },
  created() {
    // 创建时执行跳转锚点位置
    this.$nextTick(() => {
      // console.log(findId)
      this.$store.dispatch('method/anchorPoint', 'header')
    })

    this.$store.dispatch('QA/QAprocedure').then((res) => {
      this.procedure = res
      // console.log(res)
    })
  },
}
</script>

<style scoped>
    .QA-header-img {
        width: 100%;
    }
</style>
